module.exports = __webpack_public_path__ + "files/cc62fb5c139ff4ec74ef7b3474dcc7f2.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600italic.woff
// module id = 1448
// module chunks = 60